export interface AskAiIntelligenceConfigData {
  apiBaseUrl: string;
}

const defaults: AskAiIntelligenceConfigData = {
  apiBaseUrl: ''
};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface AskAiIntelligenceConfig extends AskAiIntelligenceConfigData {}

export class AskAiIntelligenceConfig {
  constructor(json?: AskAiIntelligenceConfigData) {
    json = json ?? defaults;

    Object.assign(this, defaults, json, {
      apiBaseUrl: json.apiBaseUrl.trim()
    });
  }
}
